import React, { useState, useEffect } from "react";
import axios from "axios";

const App = () => {
  const [city, setCity] = useState("");
  const [weatherData, setWeatherData] = useState([]);

  const fetchWeatherData = async () => {
    try {
      const response = await axios.get("http://localhost:5000/api/weather");
      setWeatherData(response.data);
    } catch (error) {
      console.error("Error fetching weather data:", error);
    }
  };

  const handleAddCity = async () => {
    try {
      await axios.post("http://localhost:5000/api/weather", { city });
      setCity("");
      fetchWeatherData();
    } catch (error) {
      console.error("Error adding city:", error);
    }
  };

  useEffect(() => {
    fetchWeatherData();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h1>Weather App</h1>
      <div>
        <input
          type="text"
          placeholder="Enter city"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        />
        <button onClick={handleAddCity}>Add City</button>
      </div>
      <h2>Weather Data</h2>
      <ul>
        {weatherData.map((data, index) => (
          <li key={index}>
            <strong>{data.city}</strong>: {data.temperature}°C, {data.description}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default App;